import { Component, forwardRef, Renderer2, ViewChild, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CandidateService } from '../../../service/candidate/candidate.service';
import { StringIterator, toInteger, values } from 'lodash';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AutocompleteCandidateComponent),
  multi: true,
};

@Component({
  selector: 'app-autocomplete-candidate',
  templateUrl: './autocomplete-candidate.component.html',
  styleUrls: ['./autocomplete-candidate.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class AutocompleteCandidateComponent implements ControlValueAccessor, OnInit, OnChanges {
  @Input() candidateId: number;
  @Input() businessId: any = 1;
  @Output() onMyChange = new EventEmitter();
  @Input() disabled: boolean;
  @ViewChild('input') textarea;

  public candidatesOptions: any[];
  public onChange;
  public onTouched;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;
  public query: string;
  public filters: { key: string, value: string }[];

  public sel: any;

  constructor(
    private renderer: Renderer2,
    public candidateService: CandidateService
  ) {
    this.page = 1;
    this.per_page = 10;
  }

  public ngOnInit() {

  }
  ngOnChanges() {
    //this.ngOnInit();
    this.query = undefined;
    this.filters = [];
    this.filters.push({ key: 'activated-lk', value: '1' });
    if (this.candidateId) {
      this.filters.push({ key: 'id-lk', value: String(this.candidateId) });
      this.getCandidates(this.query);
    }
  }
  writeValue(value: any) {
    const div = this.textarea.nativeElement;
    // this.renderer.setProperty(div, 'textContent', value);
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    const div = this.textarea.nativeElement;
    const action = isDisabled ? 'addClass' : 'removeClass';
    this.renderer[action](div, 'disabled');
  }

  public change($event) {
    this.onMyChange.emit(this.sel);
    this.onChange(this.sel);
    this.onTouched(this.sel);
  }

  public loadCandidatesLazy(event) {
    // this.getCandidates(event.query);
    var str = event.query;
    var res = str.replace(/\s/g, "%");
    this.filters = [];
    this.filters.push({ key: 'activated-lk', value: '1' });
    this.filters.push({ key: 'business_id', value: this.businessId });
    this.getCandidates(res);
  }

  getCandidates(query?: string) {
    this.candidateService.getCandidateLow(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
      response => {
        this.candidatesOptions = response.json().data;
        this.candidatesOptions.forEach(candidateOption => {
          candidateOption.label = candidateOption.name + ' - ' + candidateOption.identification_number;
        });
        if (this.candidateId) {
          this.candidateId = undefined;
          this.sel = this.candidatesOptions[0];
          this.filters = [];
          this.filters.push({ key: 'activated-lk', value: '1' });
        }
        // if (response.json().meta.total > response.json().meta.total_filtered) {
        //     this.totalRecords = response.json().meta.total_filtered;
        // } else {
        //     this.totalRecords = response.json().meta.total;
        // }

        // this.candidatesOptions = [];
        // candidates.forEach(element => {
        //     if (this.candidateId === element.id) {
        //         this.candidatesOptions.push({id: element.id, name: element.name, selected: true, company: element.company});
        //     } else {
        //         this.candidatesOptions.push({id: element.id, name: element.name, selected: false, company: element.company});
        //     }
        // });
      },
      error => {
        this.candidatesOptions = [];
        this.candidatesOptions.push({ id: '', name: 'Error' });
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/candidates/autocomplete-candidate/autocomplete-candidate.component.ts